<div class="image-link" role="link" tabindex="0" (click)="openLink()" (keydown.enter)="openLink()">
  <img [src]="imageSrc()" [alt]="altText()" />
</div>
